'use client';
import getLocal from '@/app/utils/getLocal';
import { loginUrl } from '@/service/util';
import { getIsLogin } from '@/utils/cookie';
import { getCookieUser } from 'eco-design-micro/EcoStat/utils/cookieFn';
import { useState } from 'react';
import CCPAModal from './modalCCPA';

export default function FooterNoShareA() {
    const { locale = 'us' } = getLocal();
    const [isCCPAModal, setIsCCPAModal] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const getIsAccredit = async () => {
        const userInfo = getCookieUser();
        const res = await fetch(`${loginUrl(locale)}/website/creditsDay/queryEngagementActivity?locale=${locale}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
                'x-appid': locale === 'us' ? 1 : 27,
            },
        });
        const data = await res.json();
        return data.code !== '401';
    };
    return (
        <>
            {['us', 'global'].includes(locale) && (
                <>
                    <div
                        onClick={async () => {
                            const isLogin1 = getIsLogin() && (await getIsAccredit());
                            setIsLogin(isLogin1);
                            setIsCCPAModal(true);
                        }}
                        className="left-ccpa"
                    >
                        Do Not Share My Personal Information
                    </div>
                    {isCCPAModal && (
                        <CCPAModal
                            callback={() => {
                                setIsCCPAModal(false);
                            }}
                            isLogin={isLogin}
                        ></CCPAModal>
                    )}
                </>
            )}
        </>
    );
}
